// Rough GPU memory estimate for the performance meter. WebGL cannot report real GPU memory,
// so this adds up the buffers we upload, the shadow map and the drawing buffers.
import { InstancedMesh, Mesh, type BufferGeometry, type Object3D } from 'three';

export function geometryBytes(root: Object3D): number {
  const seen = new Set<BufferGeometry>();
  let bytes = 0;
  root.traverse((o) => {
    if (o instanceof InstancedMesh) {
      bytes += o.instanceMatrix.array.byteLength + (o.instanceColor?.array.byteLength ?? 0);
    }
    if (!(o instanceof Mesh)) return;
    const geometry = o.geometry as BufferGeometry;
    if (seen.has(geometry)) return;
    seen.add(geometry);
    for (const attribute of Object.values(geometry.attributes)) bytes += attribute.array.byteLength;
    bytes += geometry.index?.array.byteLength ?? 0;
  });
  return bytes;
}

/**
 * Drawing buffers: 4x multisampled colour and depth, plus the resolved colour buffer.
 * Shadow map: one 32-bit depth texel per pixel.
 */
export function frameBufferBytes(width: number, height: number, pixelRatio: number, shadowMapSize: number | undefined): number {
  const pixels = Math.round(width * pixelRatio) * Math.round(height * pixelRatio);
  const drawing = pixels * (4 * 4 + 4 * 4 + 4);
  const shadow = shadowMapSize ? shadowMapSize * shadowMapSize * 4 : 0;
  return drawing + shadow;
}
